import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateBannerListUseCase {
    invoke: (bannerId: number, data: FormData) => Promise<boolean>;
  }
  
  export class UpdateBannerList implements UpdateBannerListUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(bannerId: number, data: FormData){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateBannerList(bannerId, data);
        return update;
    }
  }